/**
 * Team account inquiries from the /teams page.
 *
 * Teams are provisioned by hand per contract — there is no self-serve signup —
 * so this form is the front door to a sales conversation, not an account
 * creation flow. The endpoint is served by the website's own CloudFront
 * distribution (see infrastructure/TeamInquiry.ts), NOT the product API.
 */
export interface TeamInquiry {
  teamName: string;
  contactName: string;
  contactRole: string;
  email: string;
  areaOfOperation: string;
  teamType: string;
  teamSize: string;
  notes?: string;
  /** "Select all that apply" — joined with ', ' client-side. All optional. */
  interests?: string;
  stage?: string;
  /** Marketing attribution, captured silently rather than asked for. */
  utmSource?: string;
  referrer?: string;
}

const INQUIRY_ENDPOINT = '/api/team-inquiry';

export const submitTeamInquiry = async (inquiry: TeamInquiry): Promise<void> => {
  const response = await fetch(INQUIRY_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(inquiry)
  });
  if (!response.ok) {
    throw new Error(`Team inquiry failed (${response.status})`);
  }
};
